const drone = {
  "page": {
    "loading": "Loading the drone screen...",
    "projectLoadFailed": "Could not load site information",
    "projectNoLocation": "The site has no location, so the map cannot be drawn",
  },
  "sidebar": {
    "mapping": "Mapping",
    "settings": "Drone settings",
  },
  "unavailable": {
    "title": "Drone API coming soon",
    "body": "The Dock API is not connected yet. In the development environment, you can view a mockup with NEXT_PUBLIC_DRONE_API=mock.",
  },
  "access": {
    "locked": "Checking your role — write controls are locked",
    "viewer": "View-only access — only the owner can add docks, fly, send commands, or change settings",
  },
  "error": {
    "unavailable": "The drone API is not ready yet",
    "forbidden": "No permission — only the owner can do this",
    "not_found": "The target could not be found",
    "conflict": "Could not process because it conflicts with the current state",
    "validation": "Check your input",
    "dock_busy": "The Dock is in flight, so this cannot be done right now",
    "network": "Could not send the request — try again",
    "unconfirmed": "Could not confirm the result of the request — check the flight list and the aircraft status",
  },
  "dockBar": {
    "aircraftChange": "New aircraft {{sn}} seen — confirm to bind it to this dock",
    "aircraftConfirm": "Bind aircraft",
    "label": "Drone station",
    "add": "Add Dock",
    "empty": "No registered Docks",
    "loadFailed": "Could not load the Dock list",
    "retry": "Reload",
    "unbound": "Not connected",
    "bindFailed": "Binding failed",
    "flying": "In flight",
    "resumeBinding": "Resume binding {{name}}",
    "noSelection": "Select a Dock — every feature targets the selected Dock",
    "statusButton": "{{name}} status and commands",
    "hmsCount": "HMS {{count}}",
    "hmsNone": "No HMS",
  },
  "liveness": {
    "live": "Receiving normally",
    "stale": "Receiving delayed",
    "offline": "Offline",
  },
  "status": {
    "altitude": "Relative height",
    "dockTitle": "Dock",
    "aircraftTitle": "Aircraft",
    "mode": "Work mode",
    "cover": "Cover",
    "climate": "Climate control",
    "temperature": "Internal temperature",
    "humidity": "Humidity",
    "outsideTemperature": "Outside temperature",
    "wind": "Wind speed",
    "network": "Network",
    "aircraftPower": "Aircraft power",
    "charge": "Aircraft charging",
    "flightMode": "Flight mode",
    "battery": "Battery",
    "remain": "Remaining flight time",
    "speed": "Horizontal speed",
    "lastSeen": "Last received {{time}}",
    "staleWarning": "No status received for over 10 seconds",
    "noTelemetry": "No status received yet",
    "aircraftOff": "The aircraft is off or not connected",
    "commands": "Commands",
    "coverOpen": "Open cover",
    "coverClose": "Close cover",
    "powerOn": "Turn aircraft power on",
    "powerOff": "Turn aircraft power off",
    "busy": "Cover and aircraft power commands cannot be used during flight",
    "remove": "Remove Dock",
    "minutesSeconds": "{{minutes}}m {{seconds}}s",
    "commandSent": "Command sent",
    "commandFailed": "{{dock}} · {{command}} command failed — {{reason}}",
    "commandFailedNoReason": "{{dock}} · {{command}} command failed",
  },
  "enum": {
    "unknown": "Unknown ({{value}})",
    "dockMode": {
      "0": "Idle",
      "1": "On-site debugging",
      "2": "Remote debugging",
      "3": "Updating firmware",
      "4": "Working",
      "5": "Calibration needed",
    },
    "cover": {
      "0": "Closed",
      "1": "Open",
      "2": "Half open",
      "3": "Cover abnormal",
    },
    "climate": {
      "0": "Idle",
      "1": "Cooling",
      "2": "Heating",
      "3": "Dehumidifying",
      "7": "Preparing to cool",
      "8": "Preparing to heat",
    },
    "onOff": {
      "0": "Off",
      "1": "On",
    },
    "networkQuality": {
      "0": "No signal",
      "1": "Very poor",
      "2": "Poor",
      "3": "Fair",
      "4": "Good",
      "5": "Very good",
    },
    "aircraftMode": {
      "0": "Standby",
      "1": "Preparing for takeoff",
      "2": "Ready for takeoff",
      "3": "Manual flight",
      "4": "Auto takeoff",
      "5": "Route flight",
      "9": "Auto return",
      "10": "Auto landing",
      "11": "Forced landing",
      "14": "Not connected",
    },
  },
  "hms": {
    "title": "HMS alerts",
    "empty": "No active alerts",
    "inSky": "Occurred in flight",
    "code": "Code {{code}}",
    "level": {
      "0": "Notice",
      "1": "Caution",
      "2": "Warning",
      "none": "No level",
    },
  },
  "binding": {
    "passwordOnce": "The password is shown only once — copy it now",
    "moveAsk": "Dock {{sn}} is registered in another project. Move it to this project?",
    "moveConfirm": "Move to this project",
    "titleAdd": "Add Dock",
    "titleResume": "Resume binding {{name}}",
    "stepsLabel": "Connection steps",
    "steps": {
      "1": "Dock info",
      "2": "Connection values",
      "3": "Enter in app",
      "4": "Check connection",
    },
    "currentStep": "Step {{index}} of 4 — {{name}}",
    "snLabel": "Dock SN",
    "snHelp": "Serial number on the label on the back of the Dock or in the DJI app device info",
    "nameLabel": "Dock name",
    "register": "Get connection values",
    "problem": {
      "snRequired": "Enter the SN",
      "snFormat": "Use 6–32 uppercase letters and digits",
      "snDuplicate": "This SN is already registered in this project",
      "nameRequired": "Enter a name",
      "nameTooLong": "Enter 40 characters or fewer",
    },
    "field": {
      "mqttPassword": "MQTT password",
      "org_id": "Organization ID",
      "org_name": "Organization name",
      "binding_code": "Binding code",
      "mqtt": "MQTT gateway address",
      "mqttUser": "MQTT account",
      "ntp": "NTP server",
    },
    "onceNotice": "These values are shown only once, right now. If you close the window you cannot see them again, and you must reissue them to get them again.",
    "reissuedNotice": "Reissued — the previous connection values can no longer be used.",
    "guideTitle": "Enter connection values in the DJI app",
    "guide": {
      "1": "In DJI Pilot 2 (or the Dock settings app), connect to the Dock and open “Cloud Service”.",
      "2": "Select “Third-Party Cloud” and enter the MQTT gateway address, account, and NTP server.",
      "3": "Under “Organization Binding”, enter the organization ID and binding code, and confirm the Dock name.",
      "4": "After you save, the Dock connects to the server. Press Next and wait for the connection.",
    },
    "waiting": "Waiting for the Dock to connect and finish binding",
    "bound": "Binding complete — you can select this Dock in the Dock bar",
    "failed": "Binding failed",
    "failure": {
      "invalid_binding_code": "The binding code is incorrect",
      "organization_mismatch": "This Dock is bound to a different organization",
      "license_invalid": "Dock license verification failed",
      "sn_mismatch": "The SN of the connected Dock differs from the registered SN",
      "unknown": "The server did not give a reason",
    },
    "resumeIntro": "The previous connection values cannot be viewed again. If you reissue them, the previous values become invalid and the new values are shown once.",
    "reissue": "Reissue connection values",
    "next": "Next",
    "back": "Back",
    "close": "Close",
    "done": "Done",
    "copy": "Copy {{label}}",
    "copied": "Copied",
  },
  "confirm": {
    "previewing": "The server is checking this command",
    "previewFailed": "Could not get the preview",
    "notSendable": "This cannot be sent right now",
    "expired": "The preview has expired — close and reopen. Nothing was sent.",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "title": {
      "aircraft_limits": "Apply aircraft limits",
      "eventAck": "Acknowledge alert",
      "closeRecord": "Close-out record",
      "aircraft": "Bind aircraft",
      "cover_open": "Open cover",
      "cover_close": "Close cover",
      "aircraft_power_on": "Turn aircraft power on",
      "aircraft_power_off": "Turn aircraft power off",
      "climate": "Change climate control",
      "pause": "Pause route",
      "resume": "Resume route",
      "settings": "Change flight settings",
      "removeDock": "Remove Dock",
    },
    "body": {
      "aircraft_limits": "Apply the flight profile limits to the aircraft of {{dock}}.",
      "eventAck": "Acknowledge this alert on {{dock}}. It will no longer block takeoff.",
      "closeRecord": "Save a close-out record for {{dock}} — {{reason}}.",
      "aircraft": "Bind aircraft {{sn}} to {{dock}}.",
      "cover_open": "Opens the cover of {{dock}}.",
      "cover_close": "Closes the cover of {{dock}}. Make sure no people or objects are under the cover.",
      "aircraft_power_on": "Turns on the aircraft power of {{dock}}.",
      "aircraft_power_off": "Turns off the aircraft power of {{dock}}.",
      "climate": "Changes the climate control of {{dock}} to “{{mode}}”.",
      "pause": "Pauses the route flight of {{dock}}. The aircraft will hover in place.",
      "resume": "Resumes the route flight of {{dock}} from where it stopped.",
      "settings": "Changes the altitude limits of {{dock}} to a maximum of {{max}} m and a minimum of {{min}} m.",
      "removeDock": "Removes {{dock}} from this project. To use it again, you must redo the binding from the start.",
    },
  },
  "leave": {
    "title": "A Dock is airborne",
    "body": "The flight continues even if you leave the page, but the return button and watching on this screen will no longer be available. Leave?",
    "stay": "Stay",
    "leave": "Leave",
  },
  "launch": {
    "blockedByPreparation": "Clear the items below to take off",
    "checkFailed": "not confirmed",
    "loginRemaining": "Login time left",
    "loginMinutes": "{{minutes}} min",
    "loginShort": "Launch needs at least 90 minutes of login left — sign in again",
    "title": "Run flight — confirm takeoff",
    "dock": "Target Dock",
    "plan": "Plan",
    "target": "Time series to receive photos",
    "figures": "Route {{distance}} · about {{photos}} photos · about {{minutes}} min",
    "checklistLegend": "Check each item yourself, one at a time (nothing is remembered)",
    "validFor": "Preview valid for {{seconds}} more seconds",
    "expired": "The preview has expired — preview again. No request was sent.",
    "reopen": "Preview again",
    "execute": "Take off",
    "noAutoResend": "The request is not resent after the deadline passes",
    "previewing": "The server is preparing the takeoff confirmation",
    "previewFailed": "Could not get the takeoff confirmation — preview again",
    "blocked": "Takeoff is not possible right now",
  },
  "safety": {
    "regionLabel": "Flight safety",
    "rth": "Return",
    "rthAria": "Return {{dock}} — one press sends it immediately",
    "rthStage": {
      "sending": "Sending",
      "requested": "Request received — waiting for Dock response",
      "notSent": "Not received within 3 seconds — press again",
      "refused": "The Dock refused to return — {{reason}}",
      "sendFailed": "Could not send — press again",
      "sendFailedReason": "Could not send: {{reason}} — press again",
      "returning": "Returning",
      "landed": "Landed",
    },
    "rthAccepted": "Return request sent",
  },
  "attend": {
    "button": "Watching",
    "aria": "Watch {{dock}} — extends the operator-absence return deadline",
    "sending": "Sending watch signal",
    "ok": "{{minutes}}m {{seconds}}s until watch deadline",
    "warning": "{{seconds}}s until watch deadline — press now",
    "overdue": "Watch deadline passed — the server will send a return",
    "unknown": "Watch deadline unknown",
    "absentReturn": "Return started because the operator is absent",
  },
  "login": {
    "hours": "{{hours}}h {{minutes}}m left on login",
    "minutes": "{{minutes}}m {{seconds}}s left on login",
    "unknown": "Login time remaining unknown",
    "expiring": "Under 15 minutes of login left — you will be logged out soon",
    "expired": "Login expired — log in again after landing",
  },
  "live": {
    "connecting": "Connecting to live",
    "waitingStream": "Waiting for the dock to send video",
    "playbackFailed": "Could not play the live video",
    "title": "{{dock}} live",
    "cameraLabel": "Camera",
    "camera": {
      "dock": "Dock camera",
      "aircraft_wide": "Aircraft wide",
      "aircraft_zoom": "Aircraft zoom",
      "aircraft_ir": "Aircraft thermal",
    },
    "open": "View live",
    "start": "Start live",
    "fullscreen": "Fullscreen",
    "exitFullscreen": "Exit fullscreen",
    "close": "Close live",
    "notStarted": "No live stream is on",
    "viewerNotStarted": "You can watch once the owner turns on the live stream",
    "mockSource": "Mock video",
    "videoLabel": "{{dock}} {{camera}} video",
  },
  "mapping": {
    "title": "Mapping",
    "targetLabel": "Target time series (where photos go)",
    "targetNone": "No target",
    "targetEmpty": "There is no before time series that can receive photos — add a time series on the project screen",
    "substitute": "Mock target substitute",
    "gate": {
      "noTarget": "Select a before time series to receive photos",
      "notInProject": "This is not a time series of this project",
      "notBefore": "This time series is not in a state (before) that can receive photos",
      "hasPhotos": "A time series with directly uploaded photos is not a Dock mapping target",
      "pending": "Checking the time series",
      "unreadable": "Could not load the time series list",
      "readOnly": "Mapping requested — the plan and photos of this time series are read-only",
    },
  },
  "reference": {
    "label": "Reference time series (outputs · terrain)",
    "none": "No reference",
    "noReferenceWarning": "There is no reference time series, so collision checking is not performed",
    "layers": "Outputs to overlay",
    "ortho": "Orthomosaic",
    "dsm": "DSM",
    "gis": "GIS layers",
    "gisEmpty": "This project has no GIS layers",
    "no2d": "This reference has no 2D outputs",
    "model3d": "View 3D models and BIM in the 3D view",
  },
  "plans": {
    "deleting": "Deleting — delete again to finish",
    "title": "Flight plans",
    "new": "New plan",
    "empty": "No saved plans",
    "listLabel": "Saved flight plans",
    "open": "Open {{name}}",
    "duplicate": "Duplicate {{name}}",
    "delete": "Delete {{name}}",
    "deleteTitle": "Delete plan",
    "deleteMessage": "Delete the plan “{{name}}”",
    "deleteSub": "This cannot be undone once deleted",
    "import": "Import from another project",
    "importTitle": "Import a plan from another project",
    "importEmpty": "No plans available to import",
    "importAction": "Import {{name}}",
    "importButton": "Import",
    "farWarning": "The area of the imported plan “{{name}}” is far from this site — check the area",
    "kmzBadge": "KMZ",
    "readOnly": "Read-only",
    "copySuffix": "(copy)",
  },
  "area": {
    "title": "Mapping area",
    "draw": "Draw area",
    "redraw": "Redraw",
    "drawing": "Click points on the map and double-click to finish (Esc to cancel)",
    "cancel": "Cancel drawing",
    "none": "No area",
    "points": "{{count}} vertices",
  },
  "params": {
    "speedCap": "This dock's limit is {{cap}} m/s — raise it in Drone settings to fly faster",
    "title": "Flight and capture settings",
    "name": "Plan name",
    "mode": "Mode",
    "modes": {
      "single_grid": "Single grid",
      "double_grid": "Double grid",
      "oblique": "Oblique",
    },
    "gridAngle": "Grid angle (°)",
    "frontOverlap": "Front overlap (%)",
    "sideOverlap": "Side overlap (%)",
    "altitude": "Flight altitude (m)",
    "speed": "Speed (m/s)",
    "camera": "Camera",
    "cameras": {
      "visible": "Visible",
      "thermal": "Thermal",
      "both": "Both",
    },
    "overlapBasis": "Overlap basis",
    "obliquePattern": "Oblique pattern",
    "obliquePatterns": {
      "single_grid": "Single grid",
      "double_grid": "Double grid",
      "five_direction": "Five-direction",
    },
    "obliqueTilt": "Oblique direction",
    "obliqueTilts": {
      "along_track": "Along track",
      "cross_track": "Cross track",
    },
    "obliqueTiltHelp": "Cross track looks in the two directions perpendicular to the lines. Use it to keep long lines while capturing the sides of long sites such as roads, rivers and slopes",
    "gimbalPitch": "Camera angle (°)",
    "includeNadir": "Include nadir pass",
    "sameDirectionOverlap": "Side overlap between same-direction photos is {{same}}% — raise side overlap or use five-direction if you need more",
    "flightAreaHelp": "The mapping area you drew is the photo area. Oblique lines fly out into the flight area beyond it, and flying outside the area passes over neighbouring land. Only the dock distance envelope limits that",
    "save": "Save plan",
    "saved": "Plan saved",
  },
  "preview": {
    "title": "Preview (estimate)",
    "figures": "{{lines}} lines · about {{photos}} photos · {{distance}} · about {{minutes}} min · GSD {{gsd}} cm/px",
    "invalid": "Fix the area and settings to see the preview",
    "obliqueFigures": "{{passes}} passes · {{directions}} view directions · oblique GSD {{gsd}} cm/px · up to {{outside}} outside the area",
    "covered": "The whole area is inside hazard zones and their buffer, so there are no flight lines",
  },
  "planForm": {
    "problem": {
      "required": "Enter a value",
      "notNumber": "Enter a number",
      "outOfRange": "Enter a value between {{min}} and {{max}}",
      "tooLong": "Enter {{max}} characters or fewer",
      "tooFewPoints": "Draw the area with at least {{min}} points",
    },
  },
  "hazards": {
    "title": "Hazardous facilities and areas",
    "draw": "Draw hazard area",
    "show": "Show on map",
    "empty": "No registered hazardous facilities or areas",
    "drawing": "Draw a polygon on the map (double-click to finish, Esc to cancel)",
    "formTitle": "Save hazardous facility or area",
    "kind": {
      "facility": "Facility",
      "area": "Area",
    },
    "kindLabel": "Type",
    "name": "Name",
    "height": "Height (m, optional)",
    "heightValue": "Height {{height}} m",
    "noHeight": "Height not set",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete {{name}}",
    "alwaysAvoids": "Even with the display off, routes are always built {{buffer}} m away from hazard zones, and are blocked if they cannot avoid them",
    "problem": {
      "nameRequired": "Enter a name",
      "height": "Enter a number between 0 and 1000",
    },
  },
  "route": {
    "deleting": "Deleting this route stopped midway — generate it again",
    "profileFailed": "Could not read the route profile",
    "title": "Route",
    "generate": "Generate and verify route",
    "regenerate": "Regenerate",
    "invalid": {
      "noDock": "Select a Dock in the Dock bar",
      "missing": "There is no route for this plan and Dock — generate one",
      "otherDock": "This route was made for a different Dock — regenerate it",
      "stalePlan": "The plan has changed — regenerate",
      "hazardsChanged": "Hazard zones changed — regenerate",
      "blocked": "The route is blocked and cannot be run",
    },
    "block": {
      "hazard": "Blocked because it passes through the hazard area “{{name}}”",
      "hazard_takeoff_inside": "No route can be made because the dock is inside hazard zone \"{{names}}\"",
      "hazard_area_covered": "No route can be made because the whole area is inside hazard zone \"{{names}}\" and its buffer",
      "hazard_unreachable": "No route can be made because no flight line can be reached from the dock — \"{{names}}\" blocks the way",
      "hazard_detour_limit": "No route can be made because the detour exceeds the waypoint, distance or single-flight limit — \"{{names}}\"",
      "hazard_waypoint_inside": "No route can be made because a waypoint is inside hazard zone \"{{names}}\"",
    },
    "figures": "{{waypoints}} waypoints · about {{photos}} photos · {{distance}} · about {{minutes}} min",
    "obliqueSummary": "Oblique {{pattern}}{{tilt}} · {{passes}} passes · up to {{lead}} outside the area",
    "ready": "This route is ready to run",
    "collision": "{{count}} possible collision sections — clearance to terrain or structures under {{threshold}} m",
    "noCollision": "No possible collision sections against the reference time series profile",
    "noReference": "There is no reference time series, so the profile and collision markers are not shown",
    "needSavedPlan": "Save the plan to create a route",
    "avoidance": "Avoided {{count}} hazard zones · detour +{{bypass}} · unphotographed area {{area}} m² ({{ratio}}%)",
    "warning": {
      "hazard_waypoint_buffer": "A waypoint is inside a hazard buffer — {{names}}",
      "hazard_excluded_area": "Excluded area {{area}} m² ({{ratio}}%) — no flight line passes here",
      "hazard_unreachable_part": "Unreachable part {{area}} m² removed — it is enclosed with no way in",
      "hazard_short_fragment": "Short fragments — {{dropped}} dropped ({{length}}), {{kept}} kept. Kept fragments may lack photo overlap",
      "hazard_edge_gap": "At this low altitude the buffer ({{buffer}} m) exceeds half the photo footprint — photo gaps may appear along hazard zone edges",
      "hazard_takeoff_buffer": "The dock is inside the buffer of \"{{names}}\"",
      "hazard_return_reach": "An emergency return flies straight to the dock and may pass over \"{{names}}\"",
    },
  },
  "legend": {
    "title": "Legend",
    "nadirPass": "Nadir pass {{index}}",
    "obliquePass": "Oblique pass {{index}} · view {{bearings}}",
    "obliquePassSide": "Oblique pass {{index}} · view perpendicular to lines {{bearings}}",
    "route": "Route",
    "bypass": "Detour",
    "transit": "Transit (dock ↔ route)",
    "pathStart": "S start mark",
    "pathEnd": "E end mark",
    "returnExposure": "Return exposure",
    "collision": "Possible collision",
    "excluded": "Excluded area",
    "unreachable": "Unreachable part",
    "hazard": "Hazard zone",
    "causeHazard": "Cause zone (blocked or diverted the route)",
    "area": "Photo area (mapping area)",
    "flightArea": "Flight area · up to {{outside}} outside",
    "waypoint": "Waypoint",
    "photo": "Photo point",
    "sight": "Line of sight",
    "dock": "Dock",
    "dockScene": "Dock and return altitude line",
  },
  "profile": {
    "title": "Route profile",
    "aria": "Route profile — terrain and flight height over {{distance}}, {{count}} possible collision sections",
    "terrain": "Terrain",
    "flight": "Flight",
    "collision": "Possible collision",
  },
  "flight": {
    "aircraftPending": "Confirming aircraft connection",
    "profileIncomplete": "The flight profile is incomplete — fill it in Drone settings",
    "title": "Flight",
    "run": "Run flight",
    "phase": {
      "preparing": "Preparing",
      "takeoff": "Takeoff",
      "en_route": "En route",
      "mapping": "Capturing",
      "returning": "Returning",
      "landing": "Landing",
      "landed": "Landed",
      "failed": "Failed",
    },
    "paused": "Paused",
    "pause": "Pause",
    "resume": "Resume",
    "progress": "Waypoint {{index}}/{{total}} · {{percent}}%",
    "battery": "Battery {{percent}}%",
    "photos": "{{count}} photos so far",
    "openLive": "Live",
    "needRoute": "There is no route that can be run",
    "dockBusy": "This Dock is already in flight",
    "needTarget": "Select a target time series to receive photos",
    "launched": "Takeoff request sent",
  },
  "request": {
    "title": "Mapping request",
    "action": "Request mapping",
    "flying": "Cannot request during flight",
    "noPhotos": "No photos received yet",
    "substituteTitle": "Substitute time series mapping request",
    "substituteBody": "This is a mock target substitute, so nothing is sent to the real server and only the state on this screen changes.",
    "done": "Request complete",
  },
  "flightCheck": {
    "terrainVersion": "Terrain version checked: {{version}}",
    "title": "Flight check",
    "run": "Run flight check",
    "rerun": "Check again",
    "passed": "Passed · {{time}}",
    "problem": {
      "unchecked": "Flight check has not been run",
      "failed": "Flight check failed",
      "stale": "The record is out of date — check again",
    },
    "stale": {
      "profile_changed": "Flight profile changed",
      "hazards_changed": "Hazard zones changed",
      "terrain_changed": "Terrain changed",
      "validator_changed": "Validator changed",
      "validator_unreviewed": "Unreviewed validator",
      "kmz_changed": "Route file changed",
    },
  },
  "preparation": {
    "title": "Flight preparation",
    "residual": "The last flight of this dock is still open — confirm the landing and record it",
    "eventNotFound": "This alert could not be found here — {{reason}} (event {{id}}). Resolve it elsewhere using the event number.",
    "limitsIntro": "Power on the aircraft, apply the profile limits, then power off. The server checks each step. Continue once it has powered on.",
    "power": "Aircraft power: {{state}}",
    "stepSent": "sent",
    "stepRun": "Run",
    "done": "Finish",
    "closeIntro": "A person records a landing the server missed. Check where the aircraft is yourself, then choose.",
    "closeNext": "Preview",
    "reasonLabel": "Reason",
    "noteLabel": "Note (optional)",
    "action": {
      "limits": "Prepare aircraft limits",
      "ack": "Acknowledge alert",
      "close": "Close-out record",
    },
    "step": {
      "power_on": "Power on aircraft",
      "limits": "Apply aircraft limits",
      "power_off": "Power off aircraft",
    },
    "reason": {
      "in_dock_visual": "In dock (visual)",
      "landed_outside_visual": "Landed outside dock (visual)",
      "recovered_outside_dock": "Recovered outside dock",
      "lost": "Lost",
      "destroyed": "Destroyed",
    },
    "reasonHint": {
      "in_dock_visual": "You saw the aircraft inside the dock. The next flight preparation needs this record.",
      "landed_outside_visual": "You saw the aircraft land outside the dock.",
      "recovered_outside_dock": "The aircraft was recovered outside the dock.",
      "lost": "The aircraft could not be found.",
      "destroyed": "The aircraft was destroyed.",
    },
  },
  "settings": {
    "profile": "Flight profile",
    "profileUnreadable": "Could not read the saved profile",
    "incomplete": "The profile is incomplete — flight actions stay closed",
    "digest": "Saved digest {{digest}}",
    "groupRequired": "Required",
    "groupLimits": "Flight limits",
    "groupTakeoff": "Takeoff conditions",
    "groupWatch": "Watch and stick values",
    "positionSuggested": "Filled in the position the dock reported — it becomes the value only when you save it",
    "fieldRequired": "Enter a value",
    "fieldRange": "{{min}}–{{max}}",
    "saveProfile": "Save profile",
    "confirmChanged": "Changes: {{fields}}",
    "confirmNoChange": "none",
    "confirmDigest": "First 8 characters of the new digest: {{digest}}",
    "confirmComplete": "The profile will be complete",
    "confirmIncomplete": "Still incomplete after saving: {{problems}}",
    "aircraftLimits": "Expected aircraft limits",
    "changes": "Change history",
    "changesEmpty": "No changes yet",
    "climateSaved": "Saved mode: {{mode}}",
    "climateSave": "Save mode",
    "field": {
      "latitude": "Dock latitude",
      "longitude": "Dock longitude",
      "height_m": "Dock ellipsoidal height (m)",
      "dock_position": "Dock position",
      "max_distance_m": "Max distance (m)",
      "max_height_m": "Max height (m)",
      "min_height_m": "Min height (m)",
      "rth_altitude_m": "Return altitude (m)",
      "permit_ceiling_m": "Permit ceiling (m)",
      "max_speed_mps": "Max speed (m/s)",
      "temp_min_c": "Min temperature (℃)",
      "temp_max_c": "Max temperature (℃)",
      "max_wind_mps": "Max wind (m/s)",
      "min_battery_pct": "Min battery (%)",
      "min_gnss_quality": "Min GNSS quality",
      "min_gps_number": "Min satellites",
      "link_stable_s": "Stable link (s)",
      "breach_margin_m": "Breach margin (m)",
      "position_tolerance_m": "Dock position tolerance (m)",
      "attend_timeout_s": "Operator absence (s)",
      "telemetry_lost_s": "Telemetry lost (s)",
      "route_max_points": "Max route points",
      "hover_max_s": "Max hover (s)",
      "stick_max_deflection": "Max stick deflection",
      "stick_session_max_s": "Stick session length (s)",
      "stick_floor_m": "Stick floor (m, or off)",
      "stick_descent_mps": "Floor descent speed",
      "climate_mode": "Dock climate mode",
      "obstacle_avoidance": "Obstacle avoidance",
    },
    "title": "Drone settings",
    "selectDock": "Select a Dock in the Dock bar",
    "viewOnly": "View-only access — settings cannot be changed",
    "loadFailed": "Could not load settings",
    "climate": "Dock internal temperature",
    "climateCurrent": "Currently {{temperature}} · {{state}}",
    "climateModes": {
      "off": "Off",
      "cooling": "Cooling",
      "heating": "Heating",
    },
    "climateApply": "Apply climate control",
    "envelopeAria": "Altitude envelope — flies between a minimum of {{min}} m and a maximum of {{max}} m",
    "obstacle": "Obstacle detection",
    "obstacleOn": "On",
    "obstacleNote": "Turning it off is not sent from this screen",
    "kmz": "KMZ upload",
    "kmzSelect": "Select KMZ file",
    "kmzNote": "The uploaded route joins the plan list as read-only. It is not altered, so it is blocked if it crosses a hazard zone, and it also goes through altitude envelope validation",
    "kmzOnly": "Only KMZ (.kmz) files can be uploaded",
    "kmzDone": "Imported “{{name}}”",
  },
  "map": {
    "flatBase3d": "No 3D outputs — drawn on a flat satellite base (no terrain)",
    "dock": "{{name}} Dock",
    "aircraft": "{{name}} aircraft",
    "readOnly3d": "3D is view-only — drawing is done in 2D",
  },
  "units": {
    "meters": "{{value}} m",
    "kilometers": "{{value}} km",
    "celsius": "{{value}} ℃",
    "percent": "{{value}}%",
    "mps": "{{value}} m/s",
  },
} as const;

export default drone;
